<script setup lang="ts">
  defineOptions({ name: 'SectionEmptyState' })

  import { DEFAULT_IMAGES } from '@common/core-layer'
  import OptimisedImage from '@common/media-layer/components/OptimisedImage.vue'

  import CPText from '@ui/components/CPText.vue'

  defineProps({
    image: {
      type: String,
      required: false,
      default: DEFAULT_IMAGES.GROUP_HOME,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: undefined,
    },
    useRawImageUrl: {
      type: Boolean,
      default: true,
    },
  })
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-4 rounded-lg bg-background p-8 text-center" v-bind="$attrs">
    <OptimisedImage
      :src="image"
      :alt="title"
      source="communities"
      :height="120"
      gradient-mode="none"
      img-class="object-cover"
      fallback-aspect="aspect-video"
      :use-raw-url="useRawImageUrl"
    />
    <div class="flex flex-col items-center justify-center gap-1">
      <CPText size="2xl" weight="semibold" html-tag="h3">
        {{ title }}
      </CPText>
      <CPText v-if="description" size="lg" html-tag="p" class="text-muted">
        {{ description }}
      </CPText>
    </div>
  </div>
</template>
